enum BusinessBranchStatus
{
  None,
  Deleted,
  Inactive,
  Active
}

export default BusinessBranchStatus